import React from 'react'
import CognitoUserManagement from './CognitoUserManagement'
import Loading from '../../../../common/component/Loading'
import FormatCheckTextBox from '../../../../common/component/FormatCheckTextBox'
import Window from '../../../../common/Window'

class CognitoUserDetail extends CognitoUserManagement {
  loadUserDetail (id, withLog = true) {
    this.getCognitoUser(id, (cognitoUser, logs) => {
      const userDetail = {
        enabled: cognitoUser.Enabled,
        createdDateTime: cognitoUser.UserCreateDate,
        updatedDateTime: cognitoUser.UserLastModifiedDate,
        status: cognitoUser.UserStatus,
        id: cognitoUser.Username,
        email: this.arrayGet(cognitoUser.UserAttributes, 'email'),
        name: this.arrayGet(cognitoUser.UserAttributes, 'custom:Name'),
        emailNotification: this.arrayGet(cognitoUser.UserAttributes, 'custom:emailNotification'),
        prefectures: this.arrayGet(cognitoUser.UserAttributes, 'custom:prefectures'),
        branch: this.arrayGet(cognitoUser.UserAttributes, 'custom:branch'),
        administrator: this.arrayGet(cognitoUser.UserAttributes, 'custom:administrator'),
        isMember: this.arrayGet(cognitoUser.UserAttributes, 'custom:isMember'),
        parentID: this.arrayGet(cognitoUser.UserAttributes, 'custom:ParentID')
      }
      this.setState({
        isLoaded: true,
        userDetail: userDetail,
        logs: logs
      })
    }, withLog)
  }
  inheritingEstimation (email) {
    if (email === '') {
      Window.alert('メールアドレスは必須です。')
      return false
    }
    this.setState({
      inheritingMessage: 'データ引き継ぎ中・・・'
    })
    const onSuccess = (res) => {
      if(!res.body || res.body.Username === '') {
        this.setState({
          inheritingMessage: ''
        })
        Window.alert('メールアドレスが使用されていません。')
        return false
      }
      const baseUserId = this.state.userDetail.id
      const baseUserName = this.state.userDetail.name
      const basecompanyId = this.state.userDetail.parentID
      const userId = res.body.data.Username
      const companyId = this.arrayGet(res.body.data.Attributes, 'custom:ParentID')
      this.inheritingEstimationData(baseUserId, baseUserName, basecompanyId, userId, companyId, onSuccess2)
    }
    const onSuccess2 = (res) => {
      this.setState({
        inheritingMessage: ''
      })
      if(!res.body || res.body.isOK === true) {
        Window.alert('引き継ぎが完了しました。')
        return true
      }
      Window.alert('引き継ぎが失敗しました。')
      return false
    }
    
    this.getUserDataEmail(email, onSuccess)
  }
  renderInheriting() {
    const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
    return (
      <ul className='nav nav-list' id='person-list'>
        <li className='nav-header'>過去データ引き継ぎ</li>
        <li className='text-center'>
          {this.state.saveMessage && <div className="alert alert-success">{this.state.saveMessage}</div>}
          過去の見積データの引き継ぎを行います。<br />
          以前、使用していたメールアドレスを入力し、<br />
          「データ引き継ぎ」を押下してください。<br />
          <br />
          メールアドレス：<FormatCheckTextBox className='span5' value={this.state.email} autoComplete='false' onChange={e => this.changed('email', e)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
          <hr />
          {this.state.inheritingMessage}<br />
          <button className='btn btn-small btn-primary' onClick={(e) => this.onInheritingButtonClicked('save', e)}>データ引き継ぎ</button>　
          <button className='btn btn-small btn-default' onClick={(e) => this.onInheritingButtonClicked('cancel', e)}>終了</button>
        </li>
        <li className='nav-header'></li>
      </ul>
    )
  }
  renderPageMenu (state) {
    const disableButton = (<li key='disable' className='kw-btn-area'><button id='suspend-button' rel='tooltip' title='一時無効' data-placement='bottom' className='kw-btn-info' onClick={(e) => this.onPageMenuClicked('disable', e)} ><i className='icon-eye-close icon-large' /><span>一時<br />無効</span></button></li>)
    const enableButton = (<li key='enable' className='kw-btn-area'><button id='resurrection-button' rel='tooltip' title='復活' data-placement='bottom' className='kw-btn-info' onClick={(e) => this.onPageMenuClicked('enable', e)} ><i className='icon-heart-empty icon-large' /><span>復活</span></button></li>)
    const disableOrEnable = state.userDetail.enabled ? disableButton : enableButton
    return (
      <ul className='nav nav-pills'>
        <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back', e)} ><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
        <li className='kw-btn-area'><button id='edit-button' rel='tooltip' title='編集' data-placement='bottom' className='kw-btn-success' onClick={(e) => this.onPageMenuClicked('edit', e)} ><i className='icon-edit icon-large' /><span>編集</span></button></li>
        <li key='ban' className='kw-btn-area'><button id='delete-button' rel='tooltip' title='削除' data-placement='bottom' className='kw-btn-danger' onClick={(e) => this.onPageMenuClicked('ban', e)} ><i className='icon-remove icon-large' /><span>削除</span></button></li>
        {disableOrEnable}
      </ul>
    )
  }
  renderLogs () {
    if (this.state.logs.length === 0) {
      return (
        <tr><td style={{textAlign: 'center'}}>このユーザはまだ一度もログインしておりません。</td></tr>
      )
    }
    return this.state.logs.map((log, index) => {
      const dateTime = log.actionDateTime.toString()
      return (
        <tr key={index}>
          <td>{dateTime.substr(0, 4)}/{dateTime.substr(4, 2)}/{dateTime.substr(6, 2)} {dateTime.substr(8, 2)}:{dateTime.substr(10, 2)}:{dateTime.substr(12, 2)}</td>
        </tr>
      )
    })
  }
  renderUserDetail (title, nameTitle, userDetail, temporaryPassword) {
    if(this.userRoleUrl == 'company_user') {
      return (
        <fieldset>
          <legend>{title} - 詳細</legend><br />
          {temporaryPassword && <div className="alert alert-success">ユーザーを作成しました</div>}
          <div className='control-group'><label className='control-label'>{nameTitle}</label>
            <div className='controls'>{userDetail.name}</div>
          </div>
          <div className='control-group'><label className='control-label'>企業ユーザメールアドレス</label>
            <div className='controls'>{userDetail.email}</div>
          </div>
          {temporaryPassword &&
            <div className='control-group'><label className='control-label'><b>パスワード</b></label>
              <div className='controls'><b>{temporaryPassword}</b></div>
            </div>
          }
          <div className='control-group'><label className='control-label'>通知受信可否</label>
            <div className='controls'>{(userDetail.emailNotification === 'true' || userDetail.emailNotification === 'True') ? '可' : '不可'}</div>
          </div>
          <div className='control-group'><label className='control-label'>アカウント有効/無効</label>
            <div className='controls'>{userDetail.enabled ? '有効' : '無効'}</div>
          </div>
          <div className='control-group'><label className='control-label'>作成日時</label>
            <div className='controls'>{this.utc2jst(userDetail.createdDateTime)}</div>
          </div>
          <div className='control-group'><label className='control-label'>最終更新日時</label>
            <div className='controls'>{this.utc2jst(userDetail.updatedDateTime)}</div>
          </div>
        </fieldset>
      )
    } else {
      return (
        <fieldset>
          <legend>{title} - 詳細</legend><br />
          <div className='control-group'><label className='control-label'>{nameTitle}</label>
            <div className='controls'>{userDetail.name}</div>
          </div>
          <div className='control-group'><label className='control-label'>会社所在地都道府県名</label>
            <div className='controls'>{userDetail.prefectures}</div>
          </div>
          <div className='control-group'><label className='control-label'>支部名</label>
            <div className='controls'>{userDetail.branch}</div>
          </div>
          <div className='control-group'><label className='control-label'>企業管理者名</label>
            <div className='controls'>{userDetail.administrator}</div>
          </div>
          <div className='control-group'><label className='control-label'>企業管理者メールアドレス</label>
            <div className='controls'>{userDetail.email}</div>
          </div>
          <div className='control-group'><label className='control-label'>通知受信可否</label>
            <div className='controls'>{(userDetail.emailNotification === 'true' || userDetail.emailNotification === 'True') ? '可' : '不可'}</div>
          </div>
          <div className='control-group'><label className='control-label'>アカウント有効/無効</label>
            <div className='controls'>{userDetail.enabled ? '有効' : '無効'}</div>
          </div>
          <div className='control-group'><label className='control-label'>作成日時</label>
            <div className='controls'>{this.utc2jst(userDetail.createdDateTime)}</div>
          </div>
          <div className='control-group'><label className='control-label'>最終更新日時</label>
            <div className='controls'>{this.utc2jst(userDetail.updatedDateTime)}</div>
          </div>
        </fieldset>
      )
    }
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const userDetail = this.renderUserDetail(this.userRoleName + '情報', this.nameTitle, this.state.userDetail, this.state.temporaryPassword)
    const pageMenu = this.renderPageMenu(this.state)
    const logs = this.renderLogs()
    const inheritingBox = this.renderInheriting()

    if(this.userRole == 'companyAdmin') {
      return (
        <div>
          <section className='nav-page'>
            <div className='container'>
              <div className='row'>
                <div className='span7'>
                  <header className='page-header'>
                    <h3>{this.userRoleName}情報 - 詳細<br /><small>こちらで{this.userRoleName}の情報を参照できます。</small></h3>
                  </header>
                </div>
                <div className='span9'>
                  {pageMenu}
                </div>
              </div>
            </div>
          </section>
          <section className='page container form-horizontal'>
            <div className='row'>
              <div className='span11'>
                {userDetail}
              </div>
            </div>
          </section>

          {this.state.isInheritingModalOpen && (
            <div className="modal">
              <div className="modal-content">
                <span className="close" onClick={this.toggleInheritingModal}>&times;</span>
                {inheritingBox}
              </div>
            </div>
          )}
        </div>
      )
    } else {
      return (
        <div>
          <section className='nav-page'>
            <div className='container'>
              <div className='row'>
                <div className='span7'>
                  <header className='page-header'>
                    <h3>{this.userRoleName}情報 - 詳細<br /><small>こちらで{this.userRoleName}の情報を参照できます。</small></h3>
                  </header>
                </div>
                <div className='span9'>
                  {pageMenu}
                </div>
              </div>
            </div>
          </section>
          <section className='page container form-horizontal'>
            <div className='row'>
              <div className='span11'>
                {userDetail}
              </div>
              <div className='span5'>
                <div className="btn-group-box text-center">
                  <button className="text-center inheriting kw-btn-primary" onClick={this.toggleInheritingModal}>
                    <span className="button-text"> 過去データ引き継ぎ </span>
                  </button>
                </div>
              </div>
            </div>
          </section>

          {this.state.isInheritingModalOpen && (
            <div className="modal">
              <div className="modal-content">
                <span className="close" onClick={this.toggleInheritingModal}>&times;</span>
                {inheritingBox}
              </div>
            </div>
          )}
        </div>
      )
    }
  }
}

export default CognitoUserDetail



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/abstract/CognitoUserDetail.js